import { gql } from "@apollo/client";

export const ADD_PHONE = gql`
    mutation AddPhone(
        $phoneNumber: String!,
        $phoneType: TipoTelefono!
        $principal: Boolean
    ) {
        agregarTelefono(input: {
            numero: $phoneNumber
            tipoTelefono: $phoneType
            principal: $principal
        }) {
            telefono {
                id
                numero
                principal
                tipoTelefono
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const UPDATE_PHONE = gql`
    mutation UpdatePhone(
        $id: ID!,
        $phoneNumber: String!,
        $phoneType: TipoTelefono!,
        $principal: Boolean
    ) {
        editarTelefono(input: {
            id: $id
            numero: $phoneNumber
            tipoTelefono: $phoneType
            principal: $principal
        }) {
            telefono {
                id
                numero
                tipoTelefono
                principal
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const MAKE_PRIMARY_PHONE = gql`
    mutation UpdatePhone(
        $id: ID!,
        $principal: Boolean!
    ) {
        editarTelefono(input: {
            id: $id
            principal: $principal
        }) {
            telefono {
                id
                principal
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const DELETE_PHONE = gql`
    mutation DeletePhone($id: ID!) {
        eliminarTelefono(id: $id) {
            telefono {
                id
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;
